//funzione associare a ogni layer la sua icona
import React from 'react';
function ImageLayer(props){

     const url = props.nodes.serviceUrl + "&request=GetLegendGraphic&format=image%2Fpng&width=30&height=30&layer=" + props.nodes.layerName

return (<div>
         <img 
      src={url}
      alt="layer"
      />
</div>)

}
export default ImageLayer




